var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRevoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7489_49753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 5.99968H10.946L9.40601 3.87968C9.28189 3.70982 9.11933 3.57173 8.93163 3.47672C8.74392 3.38171 8.5364 3.33247 8.32601 3.33301H3.99935C3.64573 3.33301 3.30659 3.47349 3.05654 3.72354C2.80649 3.97359 2.66602 4.31272 2.66602 4.66635V19.333C2.66602 19.6866 2.80649 20.0258 3.05654 20.2758C3.30659 20.5259 3.64573 20.6663 3.99935 20.6663H19.9993C20.353 20.6663 20.6921 20.5259 20.9422 20.2758C21.1922 20.0258 21.3327 19.6866 21.3327 19.333V7.33301C21.3327 6.97939 21.1922 6.64025 20.9422 6.3902C20.6921 6.14015 20.353 5.99968 19.9993 5.99968ZM19.9993 19.333H3.99935V8.66635H8.87268C9.2263 8.66635 9.56544 8.52587 9.81549 8.27582C10.0655 8.02577 10.206 7.68663 10.206 7.33301H3.99935V4.66635H8.32601L10.066 7.05968C10.1281 7.14461 10.2094 7.21365 10.3032 7.26116C10.3971 7.30866 10.5008 7.33328 10.606 7.33301H19.9993V19.333Z",
    fill: "#002E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6651 16.998L9 15.3313L10.6657 13.6656",
    stroke: "#002E68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7761 11.9997H14.5522C15.6626 11.9997 16.2179 12.555 16.2179 13.6654C16.2179 14.7758 15.6626 15.3311 14.5522 15.3311H9",
    stroke: "#002E68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7489_49753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoke);
export default __webpack_public_path__ + "static/media/revoke.b468bb2eae62e35d0ec4f2cfddb244d7.svg";
export { ForwardRef as ReactComponent };